import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { EmailCompletionService } from '../completion.service';
import { SessionService } from 'src/app/session.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { L } from '@angular/cdk/keycodes';
import { Subject } from 'rxjs';
import { UiService } from 'src/app/ui/ui.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-completion',
  templateUrl: './completion.component.html',
  styleUrls: ['./completion.component.scss']
})
export class EmailCompletionComponent implements OnInit {

  private onComponentDestroy = new Subject();

  public form: FormGroup;

  public fields: any[] = [];

  public results: any;

  constructor(
    private svc: EmailCompletionService,
    private sessionSvc: SessionService,
    private fb: FormBuilder,
    private uiService: UiService,
  ) {
    this.form = this.fb.group({
      name: [''],
      prompt: [''],
      generateSubject: ['no'],
      subjectField: [null],
      subject: [null],
      bodyFields: [[]]
    });
    this.fields = this.sessionSvc.currentAccountValue!.catalog.app_users.profile
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  generateSubjectChange(event: any) {
    this.form.controls.subjectField.setValue(null);
    this.form.controls.bodyFields.setValue([]);
  }

  subjectFieldChange(event: any) {
    if(this.form.controls.bodyFields.value.indexOf(event.value) > -1){
      this.form.controls.bodyFields.value.splice(this.form.controls.bodyFields.value.indexOf(event.value), 1);
    }
  }

  bodyFieldClick(fieldId: any) {
    if((this.form.controls.subjectField.value === fieldId) || (this.form.controls.generateSubject.value == 'yes' && this.form.controls.bodyFields.value.length >= 2) || (this.form.controls.generateSubject.value == 'no' && this.form.controls.bodyFields.value.length >= 3)){
      return;
    }
    if(this.form.controls.bodyFields.value.indexOf(fieldId) == -1){
      this.form.controls.bodyFields.value.push(fieldId);
    }
  }

  highlightBodyField(fieldId: string): boolean {
    return this.form.controls.bodyFields.value.indexOf(fieldId) > -1 || this.form.controls.subjectField.value == fieldId;
  }

  removableBodyField(fieldId: string): boolean {
    return this.form.controls.bodyFields.value.indexOf(fieldId) > -1;
  }

  removeBodyField(fieldId: string) {
    let index = this.form.controls.bodyFields.value.indexOf(fieldId);
    if(index > -1){
      this.form.controls.bodyFields.value.splice(index, 1);
    }
  }

  disableGeneratePreview(): boolean {
    if(this.form.controls.name.value === ''){
      return true;
    }
    if(this.form.controls.prompt.value === ''){
      return true;
    }
    if(this.form.controls.generateSubject.value === 'yes' && this.form.controls.subjectField.value === null){
      return true;
    }
    if(this.form.controls.generateSubject.value === 'no' && (this.form.controls.subject.value === '' || this.form.controls.subject.value === null)){
      return true;
    }
    if(this.form.controls.generateSubject.value === 'no' && this.form.controls.bodyFields.value.length === 0){
      return true;
    }
    return false;
  }

  generatePreview() {

    this.uiService
      .waitForEvent(
        this.svc.generatePreview(this.sessionSvc.currentAccountValue!.accountID, this.sessionSvc.currentAppValue!.id, {
          generateSubject: this.form.controls.generateSubject.value === 'yes',
          subjectField: this.form.controls.subjectField.value,
          subject: this.form.controls.generateSubject.value === 'yes' ? null : this.form.controls.subject.value,
          bodyFields: this.form.controls.bodyFields.value,
          prompt: this.form.controls.prompt.value,
        })
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((response) => {
        this.results = response;
      });

  }

}
